import { render } from "./vcompany_aliset.vue?vue&type=template&id=bcfdb3a6&scoped=true"
import script from "./vcompany_aliset.vue?vue&type=script&lang=js"
export * from "./vcompany_aliset.vue?vue&type=script&lang=js"

import "./vcompany_aliset.vue?vue&type=style&index=0&id=bcfdb3a6&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcfdb3a6"]])

export default __exports__